module.exports = __webpack_public_path__ + "img/canvas-morning-warm.da53d540.jpg";